import { CalendarSettingsViewModel } from "../../calendar-settings/api/calendar-settings"
import { createHolidayChecker, createWeekendChecker } from "../../calendar-settings/utils/date"

type CreateWeekDateClassTemplateArgs = {
  calendarSettings: CalendarSettingsViewModel
}

const WEEKEND_OR_HOLIDAY_CLASS = "weekend"

export const createWeekDateClassTemplate = ({ calendarSettings }: CreateWeekDateClassTemplateArgs) => {
  const checkIsWeekend = createWeekendChecker(calendarSettings)
  const checkIsHoliday = createHolidayChecker(calendarSettings)

  return function weekDateClassTemplate(start: Date, end: Date, event: any) {
    const isWeekend = checkIsWeekend(start)
    const isHoliday = checkIsHoliday(start)
    return isWeekend || isHoliday ? WEEKEND_OR_HOLIDAY_CLASS : ""
  }
}
